export default {
  // Navigation
  nav_home: 'Accueil',
  nav_dashboard: 'Tableau de bord',
  nav_orders: 'Commandes',
  nav_wallet: 'Portefeuille',
  nav_analytics: 'Analyses',
  nav_referral: 'Parrainage',
  nav_account: 'Compte',
  nav_notifications: 'Notifications',
  nav_logout: 'Déconnexion',
  nav_login: 'Connexion',
  nav_signup: 'Inscription',
  nav_deposit_requests: 'Demandes de dépôt',
  nav_withdraw_requests: 'Demandes de retrait',
  nav_support_ticket: 'Ticket de support',
  nav_system_logs: 'Logs système',
  nav_announcements: 'Annonces',
  nav_activity_logs: 'Logs d\'activité',
  nav_settings: 'Paramètres',
  nav_section_main: 'Principal',
  nav_user_active: 'En ligne',
  nav_more: 'Plus',
  nav_logout_confirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
  nav_language: 'Langue',

  // Dashboard
  dashboard_welcome: 'Bon retour',
  dashboard_total_earnings: 'Gains totaux',
  dashboard_pending_orders: 'Commandes en attente',
  dashboard_completed_orders: 'Commandes terminées',
  dashboard_commission_rate: 'Taux de commission',
  dashboard_quick_actions: 'Actions rapides',
  dashboard_recent_orders: 'Commandes récentes',
  dashboard_recent_activity: 'Activité récente',
  dashboard_wallet_balance: 'Solde du portefeuille',
  dashboard_deposit: 'Dépôt',
  dashboard_withdraw: 'Retrait',
  dashboard_view_all: 'Tout afficher',
  greeting_morning: 'Bon matin',
  greeting_afternoon: 'Bon après-midi',
  greeting_evening: 'Bonsoir',
  dashboard_greeting_desc: 'Suivez vos gains, complétez vos commandes et gérez votre compte en un seul endroit. Votre parcours vers le succès continue ici !',

  // Dashboard Stats
  stats_available_balance: 'Solde disponible',
  stats_total_withdrawn: 'Total retiré',
  stats_total_deposit: 'Total déposé',
  stats_pending_orders: 'Commandes en attente',
  stats_orders_suffix: ' commandes',
  stats_task_earnings: 'Gains des tâches',
  stats_lifetime_earning: 'Gains cumulés',

  // Orders
  orders_title: 'Mes commandes',
  orders_all: 'Toutes les commandes',
  orders_pending: 'En attente',
  orders_completed: 'Terminé',
  orders_cancelled: 'Annulé',
  orders_order_id: 'ID Commande',
  orders_platform: 'Plateforme',
  orders_amount: 'Montant',
  orders_commission: 'Commission',
  orders_status: 'Statut',
  orders_date: 'Date',
  orders_no_orders: 'Aucune commande trouvée',

  // Wallet
  wallet_title: 'Mon portefeuille',
  wallet_available_balance: 'Solde disponible',
  wallet_pending_balance: 'Solde en attente',
  wallet_total_withdrawn: 'Total retiré',
  wallet_deposit_now: 'Déposer maintenant',
  wallet_withdraw_now: 'Retirer maintenant',
  wallet_transaction_history: 'Historique des transactions',
  wallet_deposit_history: 'Historique des dépôts',
  wallet_withdrawal_history: 'Historique des retraits',
  wallet_deposit_desc: "Ajoutez de l'argent à votre portefeuille باستخدام les méthodes de paiement disponibles.",
  wallet_no_deposits: "Aucun dépôt trouvé.",
  wallet_withdraw_history: "Historique des retraits",
  wallet_withdraw_desc: "Retirez de l'argent de votre portefeuille.",
  wallet_no_withdrawals: "Aucun retrait trouvé.",
  wallet_no_withdrawals_desc: "Vous n'avez effectué aucun retrait pour le moment.",

  // Analytics
  analytics_title: 'Analyses',
  analytics_earnings_overview: 'Aperçu des gains',
  analytics_platform_breakdown: 'Répartition par plateforme',
  analytics_performance_metrics: 'Mesures de performance',
  analytics_top_products: 'Top produits',
  analytics_this_month: 'Ce mois',
  analytics_last_month: 'Mois dernier',
  analytics_total_revenue: 'Revenu total',
  analytics_avg_order_value: 'Valeur moyenne des commandes',

  // Referral
  referral_title: 'Programme de parrainage',
  referral_your_code: 'Votre code de parrainage',
  referral_copy_code: 'Copier le code',
  referral_share_link: 'Partager le lien',
  referral_total_referrals: 'Total parrainages',
  referral_active_referrals: 'Parrainages actifs',
  referral_referral_earnings: 'Gains de parrainage',
  referral_invite_friends: 'Inviter des amis',

  // Account
  account_title: 'Paramètres du compte',
  account_profile: 'Profil',
  account_security: 'Sécurité',
  account_notifications: 'Notifications',
  account_kyc: 'Vérification KYC',
  account_phone: 'Numéro de téléphone',
  account_two_factor: 'Authentification à deux facteurs',
  account_save_changes: 'Enregistrer les modifications',
  account_cancel: 'Annuler',

  // Auth & Common
  auth_email: 'E-mail',
  auth_password: 'Mot de passe',
  auth_confirm_password: 'Confirmer le mot de passe',
  auth_forgot_password: 'Mot de passe oublié ?',
  auth_remember_me: 'Se souvenir de moi',
  auth_login_button: 'Connexion',
  auth_signup_button: 'S\'inscrire',
  auth_already_have_account: 'Déjà un compte ?',
  auth_dont_have_account: "Pas encore de compte ?",
  auth_reset_password: 'Réinitialiser le mot de passe',
  auth_verify_email: 'Vérifier l\'e-mail',
  auth_live_platform: 'Plateforme en direct',
  auth_security_verification: 'Vérification de sécurité',
  auth_captcha_refresh: 'Actualiser',
  auth_captcha_placeholder: 'Résultat',
  auth_captcha_error: 'Somme incorrecte, veuillez réessayer',
  auth_branding_title: 'Transformez les promotions en',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Revenu Réel',
  auth_branding_desc: 'Rejoignez des milliers de promoteurs qui gagnent des commissions quotidiennes auprès des plus grandes marques mondiales de commerce électronique.',
  auth_sign_in_to_account: 'Connectez-vous à votre compte {{system_name}}',
  auth_email_placeholder: 'vous@exemple.com',
  auth_password_placeholder: 'Entrez votre mot de passe',
  auth_signing_in: 'Connexion...',
  auth_free_to_join: 'Inscription Gratuite',
  auth_signup_branding_title: 'Commencez à gagner',
  auth_signup_branding_highlight: 'Dès le premier jour',
  auth_signup_branding_desc: 'Aucune expérience requise. Inscrivez-vous en 2 minutes et commencez à accomplir des tâches pour les plus grandes marques de commerce électronique.',
  auth_how_it_works: 'Comment ça marche',
  auth_signup_desc: 'Rejoignez {{system_name}} et commencez à gagner des commissions dès aujourd\'hui — c\'est gratuit !',
  auth_step_1: 'Créez votre compte gratuit',
  auth_step_2: 'Parcourez et acceptez des tâches',
  auth_step_3: 'Complétez et gagnez des commissions',
  auth_signup_step_1_title: 'Créer un compte',
  auth_signup_step_1_desc: 'Commencez votre voyage',
  auth_signup_step_2_title: 'Compléter des tâches',
  auth_signup_step_2_desc: 'Gagnez des commissions quotidiennes',
  auth_signup_step_3_title: 'Retirer des fonds',
  auth_signup_step_3_desc: 'Retraits rapides et sécurisés',
  auth_benefit_1_title: 'Sûr et de confiance',
  auth_benefit_1_desc: 'Sécurité de niveau bancaire pour vos gains',
  auth_benefit_2_title: 'Paiements instantanés',
  auth_benefit_2_desc: 'Retirez vos gains dans les 24 heures',
  auth_benefit_3_title: 'Communauté mondiale',
  auth_benefit_3_desc: 'Rejoignez plus de 12 000 promoteurs actifs',
  auth_benefit_4_title: 'Support 24/7',
  auth_benefit_4_desc: 'Obtenez de l\'aide quand vous en avez besoin',
  auth_strength_weak: 'Faible',
  auth_strength_fair: 'Moyen',
  auth_strength_good: 'Bon',
  auth_strength_strong: 'Fort',
  auth_password_strength: 'Force du mot de passe : {{strength}}',
  auth_social_proof: 'Rejoignez plus de {{count}} gagnants',
  auth_passwords_match: 'Les mots de passe correspondent',
  auth_creating_account: 'Création du compte...',
  auth_phone_number: 'Numéro de téléphone',
  auth_phone_optional: '(Optionnel)',
  auth_phone_placeholder: 'Votre numéro de téléphone',
  auth_full_name: 'Nom complet',
  auth_full_name_placeholder: 'Jean Dupont',
  auth_password_min_chars: 'Au moins 8 caractères',
  auth_confirm_password_placeholder: 'Répétez votre mot de passe',
  auth_agree_to: 'J\'accepte les',
  auth_terms_of_service: 'Conditions d\'utilisation',
  auth_privacy_policy: 'Politique de confidentialité',
  auth_and: 'et la',
  auth_create_free_account: 'Créer un compte gratuit',

  common_loading: 'Chargement...',
  common_save: 'Enregistrer',
  common_cancel: 'Annuler',
  common_delete: 'Supprimer',
  common_edit: 'Modifier',
  common_view: 'Voir',
  common_search: 'Rechercher',
  common_filter: 'Filtrer',
  common_export: 'Exporter',
  common_import: 'Importer',
  common_submit: 'Envoyer',
  common_close: 'Fermer',
  common_confirm: 'Confirmer',
  common_success: 'Succès',
  common_error: 'Erreur',
  common_warning: 'Avertissement',
  common_announcement: 'Annonce',

  val_full_name_required: 'Le nom complet est requis',
  val_email_required: 'L\'e-mail est requis',
  val_password_required: 'Le mot de passe est requis',
  val_password_min: 'Le mot de passe doit contenir au moins 8 caractères',
  val_passwords_dont_match: 'Les mots de passe ne correspondent pas',
  security_pin_6_err: 'Le code PIN doit comporter précisément 6 chiffres.',
  security_pin_digit_err: 'Le code PIN ne doit contenir que des chiffres.',
  val_agree_terms: 'Vous devez accepter les conditions',
  val_conn_error: 'Erreur de connexion. Veuillez réessayer.',

  // Homepage
  home_hero_title: 'Gagnez des commissions auprès des meilleures plateformes de commerce électronique',
  home_hero_subtitle: 'Rejoignez des milliers d\'utilisateurs qui gagnent des commissions quotidiennes sur Walmart, Alibaba et AliExpress',
  home_get_started: 'Commencer maintenant',
  home_learn_more: 'En savoir plus',
  home_how_it_works: 'Comment ça marche',
  home_features: 'Caractéristiques',
  home_why_choose_us: 'Pourquoi nous choisir',
  home_features_title: 'Fonctionnalités puissantes',
  home_features_subtitle: 'Tout ce dont vous avez besoin pour commencer à gagner de l\'argent en ligne. Conçu pour votre succès.',
  home_commission_tiers: 'Tiers de commission',
  home_testimonials: 'Ce que disent nos utilisateurs',
  home_faq: 'Questions fréquemment posées',
  home_cta_title: 'Prêt à commencer à gagner ?',
  home_cta_subtitle: 'Rejoignez notre communauté aujourd\'hui et commencez à gagner des commissions',
  home_trusted_partner: 'Plateformes partenaires de confiance',
  home_secure_platform: 'Plateforme sécurisée',
  home_instant_payouts: 'Paiements instantanés',
  home_active_users: 'Utilisateurs actifs',
  home_paid_out: 'Payé',
  home_total_paid_out: 'Total payé',
  home_user_rating: 'Évaluation des utilisateurs',
  home_countries: 'Pays',
  home_commission_badge: 'Potentiel de gain',
  home_commission_title: 'Taux de commission',
  home_commission_desc: 'Un solde plus élevé débloque de meilleurs taux de commission. Chaque session attribue exactement 25 commandes — complétez jusqu\'à 4 sessions par jour pour des gains maximum.',
  home_tier_popular: 'Le plus populaire',
  home_tier_commission_per_order: 'Commission par commande',
  home_tier_earn_examples: 'Exemples de gains :',
  home_tier_order: 'commande',
  home_tier_batch_earn: 'Gain par lot de 25 commandes :',
  home_tier_daily_potential: 'Potentiel quotidien (4 lots × 25 commandes)',
  home_tier_max_daily: 'Jusqu\'à 100 commandes par jour',
  home_tier_benefit_1: '25 commandes par lot',
  home_tier_benefit_2: 'Max 4 lots par jour',
  home_tier_benefit_3: 'Crédit de commission immédiat',
  home_tier_above: 'Au-dessus de',
  home_tier_no_tiers: 'Aucun tiers de commission trouvé.',

  // Comparison Section
  home_compare_badge: 'La différence',
  home_compare_title: 'Pourquoi nous sommes meilleurs',
  home_compare_subtitle: 'Comparez notre plateforme avec les emplois traditionnels à temps partiel et découvrez pourquoi des milliers nous choisissent.',
  home_compare_feature: 'Fonctionnalité',
  home_compare_traditional: 'Emplois traditionnels',
  home_compare_our_platform: 'Notre plateforme',
  home_compare_f1: 'Flexibilité',
  home_compare_f1_trad: 'Horaires fixes',
  home_compare_f1_our: 'Travaillez n\'importe quand, n\'importe où',
  home_compare_f2: 'Paiements',
  home_compare_f2_trad: 'Mensuels ou bimensuels',
  home_compare_f2_our: 'Instantanné / Le jour même',
  home_compare_f3: 'Exigences',
  home_compare_f3_trad: 'Expérience/CV/Entretien',
  home_compare_f3_our: 'Aucune - Juste un smartphone',
  home_compare_f4: 'Croissance',
  home_compare_f4_trad: 'Augmentations annuelles fixes',
  home_compare_f4_our: 'Croissance illimitée basée sur les tiers',

  // Testimonials
  home_testi_badge: 'Histoires de succès',
  home_testi_title: 'Approuvé par des milliers',
  home_testi_subtitle: 'Découvrez les témoignages de notre communauté mondiale de promoteurs qui ont transformé leurs revenus.',
  home_testi_no_stories: 'Aucune histoire de succès disponible pour le moment.',
  home_testi_total_earned: 'Total gagné',
  home_testi_time_period: 'Période',
  home_testi_verified: 'Utilisateur vérifié',
  home_testi_avg_rating: 'Note moyenne',
  home_testi_satisfaction_rate: 'Taux de satisfaction',
  home_testi_support_available: 'Support disponible',

  // FAQ
  home_faq_badge: 'Support',
  home_faq_title: 'Questions courantes',
  home_faq_subtitle: 'Tout ce que vous devez savoir pour commencer et gagner.',
  home_faq_no_data: 'Aucune question trouvée.',

  // Trust Bar
  home_trust_badge: 'Confiance mondiale',
  home_trust_title: 'Approuvé par les plus grandes marques',
  home_trust_desc: 'Nous sommes partenaires des plus grandes plateformes de commerce électronique mondiales pour fournir des services de promotion vérifiés.',

  // Feature Section
  feature_1_title: 'Paiements instantanés',
  feature_1_desc: 'Gagnez vos commissions immédiatement après la validation de la commande. Retirez n\'importe quand sans délai.',
  feature_1_detail_1: 'Crédit de commission en temps réel',
  feature_1_detail_2: 'Multiples options de retrait',
  feature_1_detail_3: 'Aucun seuil minimum',
  feature_2_title: 'Plateforme sécurisée',
  feature_2_desc: 'Le cryptage de niveau bancaire protège vos données et vos gains. Approuvé par des milliers d\'utilisateurs dans le monde.',
  feature_2_detail_1: 'Cryptage SSL activé',
  feature_2_detail_2: 'Authentification à deux facteurs',
  feature_2_detail_3: 'Audits de sécurité réguliers',
  feature_2_detail_4: 'Confidentialité des données garantie',
  feature_3_title: 'Horaires flexibles',
  feature_3_desc: 'Travaillez quand vous voulez, où que vous soyez. Complétez vos commandes à votre rythme sans horaire fixe.',
  feature_3_detail_1: 'Pas d\'heures de travail fixes',
  feature_3_detail_2: 'Travaillez d\'où vous voulez',
  feature_3_detail_3: 'Choisissez votre propre rythme',
  feature_3_detail_4: 'Disponibilité le week-end',
  feature_4_title: 'Gains progressifs',
  feature_4_desc: 'Débloquez des taux de commission plus élevés à mesure que vous complétez des commandes. Augmentez vos revenus avec chaque passage de tiers.',
  feature_4_detail_1: 'Taux de commission par tiers',
  feature_4_detail_2: 'Mise à jour automatique des tiers',
  feature_4_detail_3: 'Récompenses de performance',
  feature_5_title: 'Plateforme mondiale',
  feature_5_desc: 'Travaillez avec des marques internationales partout dans le monde. Support multi-devises inclus.',
  feature_5_detail_1: 'Disponible dans le monde entier',
  feature_5_detail_2: 'Support multi-devises',
  feature_5_detail_3: 'Méthodes de paiement locales',
  feature_6_title: 'Support 24/7',
  feature_6_desc: 'Notre équipe de support dédiée est toujours prête à vous aider. Obtenez de l\'aide via le chat en direct, par e-mail ou par téléphone.',
  feature_6_detail_1: 'Chat en direct disponible',
  feature_6_detail_2: 'Support e-mail 24/7',
  feature_6_detail_3: 'Assistance téléphonique',
  feature_6_detail_4: 'FAQ complète',
  feature_7_title: 'Programme de parrainage',
  feature_7_desc: 'Gagnez des revenus supplémentaires en invitant des amis. Obtenez des commissions à vie sur les gains de vos filleuls.',
  feature_7_detail_1: 'Gains de parrainage à vie',
  feature_7_detail_2: 'Parrainages illimités',
  feature_7_detail_3: 'Outils de partage faciles',
  feature_7_detail_4: 'Bonus incitatifs',
  feature_8_title: 'Multi-devises',
  feature_8_desc: 'Prise en charge des principales devises et méthodes de paiement. Choisissez ce qui vous convient le mieux.',
  feature_8_detail_1: 'Support USD, EUR, GBP',
  feature_8_detail_2: 'Virement bancaire disponible',
  feature_8_detail_3: 'Intégration e-wallet',
  feature_8_detail_4: 'Options crypto à venir',
  feature_9_title: 'Notifications instantanées',
  feature_9_desc: 'Restez à jour avec des alertes en temps réel pour les nouvelles commandes, les gains et les activités du compte.',
  feature_9_detail_1: 'Notifications push',
  feature_9_detail_2: 'Alertes e-mail',
  feature_9_detail_3: 'Mises à jour par SMS',
  feature_9_detail_4: 'Messages intégrés à l\'application',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Processus simple',
  home_how_it_works_title: 'Comment ça marche',
  home_how_it_works_subtitle: 'Commencez à gagner en 4 étapes simples. Aucune expérience requise, suivez simplement le processus et regardez vos gains croître.',
  home_cta_ready_title: 'Prêt à commencer votre voyage ?',
  home_cta_ready_desc: 'Rejoignez des milliers d\'utilisateurs qui gagnent déjà quotidiennement. Votre première commission n\'est qu\'à quelques minutes !',
  home_cta_avg_time: 'Temps moyen pour le premier gain :',
  home_cta_15_mins: '15 minutes',
  home_cta_new_users: 'Nouveaux utilisateurs aujourd\'hui :',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Places limitées disponibles ce mois-ci',
  home_cta_main_title: 'Commencez à gagner de l\'argent',
  home_cta_today: 'Dès aujourd\'hui !',
  home_cta_main_desc: 'Rejoignez des milliers d\'utilisateurs qui gagnent déjà des commissions quotidiennes. Sans expérience, horaires flexibles, paiements instantanés. Votre liberté financière commence ici.',
  home_cta_spots_remaining: 'Places restantes',
  home_cta_new_users_today: 'Nouveaux utilisateurs aujourd\'hui',
  home_cta_create_account: 'Créer un compte gratuit',
  home_cta_sign_in: 'Se connecter',
  home_cta_secure: '100 % sécurisé',
  home_cta_payouts: 'Paiements en 24-48h',
  home_cta_rating: 'Note de 4,9/5',
  home_cta_active_users: 'Utilisateurs actifs',
  home_cta_total_paid: 'Total payé',
  home_cta_orders_done: 'Tâches terminées',
  home_cta_satisfaction: 'Satisfaction',
  home_cta_guarantee_title: 'Garantie de remboursement',
  home_cta_guarantee_desc: 'Pas satisfait ? Récupérez votre dépôt sous 7 jours',

  // Footer Branding & Extras
  footer_brand_desc: 'La première plateforme mondiale de promotion du commerce électronique. Rejoignez notre réseau mondial de promoteurs dès aujourd\'hui et commencez à gagner des commissions auprès des meilleures marques.',
  footer_ssl_secure: 'SSL Sécurisé',
  footer_aes_256: 'Cryptage AES-256',
  footer_cookie_policy: 'Politique relative aux cookies',
  footer_disclaimer: 'Clause de non-responsabilité',
  footer_all_rights: 'Tous droits réservés.',

  // Announcements
  announcement_withdrawal_delay_title: 'Délai de traitement des retraits',
  announcement_withdrawal_delay_summary: 'Les retraits peuvent prendre jusqu\'à 72 heures en raison d\'un volume important. Veuillez anticiper vos demandes.',
  announcement_date_june_14: '14 juin 2025',

  // How It Works Steps
  step_1_title: 'Inscription',
  step_1_desc: 'Créez votre compte en moins de 2 minutes.',
  step_1_detail_1: 'Entrez vos informations de base',
  step_1_detail_2: 'Vérifiez votre adresse e-mail',
  step_1_detail_3: 'Sécurisez votre compte',
  step_1_detail_4: 'Accès immédiat au tableau de bord',
  step_2_title: 'Choisir une tâche',
  step_2_desc: 'Choisissez parmi les tâches de promotion disponibles.',
  step_2_detail_1: 'Filtrer par plateforme',
  step_2_detail_2: 'Voir les taux de commission',
  step_2_detail_3: 'Accepter plusieurs tâches',
  step_2_detail_4: 'Mises à jour des tâches en temps réel',
  step_3_title: 'Compléter la tâche',
  step_3_desc: 'Complétez les tâches selon les instructions.',
  step_3_detail_1: 'Instructions faciles à suivre',
  step_3_detail_2: 'Soumission rapide des tâches',
  step_3_detail_3: 'Vérification automatique',
  step_3_detail_4: 'Interface optimisée pour mobile',
  step_4_title: 'Gagner et retirer',
  step_4_desc: 'Soyez payé pour chaque tâche accomplie.',
  step_4_detail_1: 'Suivi des gains en temps réel',
  step_4_detail_2: 'Seuil de retrait très bas',
  step_4_detail_3: 'Multiples méthodes de paiement',
  step_4_detail_4: 'Support de retrait 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Restez informé',
  footer_stay_loop_desc: 'Recevez les dernières mises à jour, conseils et offres exclusives directement dans votre boîte de réception.',
  footer_subscribe: 'S\'abonner',
  footer_subscribe_placeholder: 'Entrez votre adresse e-mail',
  footer_trusted_secure: 'FIABLE ET SÉCURISÉ :',
  footer_ssl_secured: 'Sécurité SSL',
  footer_ssl_secured_desc: 'SSL 256 bits',
  footer_aes_encryption: 'Cryptage AES-256',
  footer_aes_encryption_desc: 'Niveau bancaire',
  footer_kyc_compliant: 'Conforme KYC',
  footer_kyc_compliant_desc: 'Vérifié',
  footer_gdpr_compliant: 'Conforme RGPD',
  footer_gdpr_compliant_desc: 'Données Protégées',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Certifié',
  footer_platform: 'PLATEFORME',
  footer_support: 'SUPPORT',
  footer_legal: 'JURIDIQUE',
  footer_help_center: 'Centre d\'aide',
  footer_contact_us: 'Contactez-nous',
  footer_payments_label: 'Paiements :',
  home_live_activity_title: 'Activité de la Plateforme en Direct',
  home_recent_activity_title: 'Activité Récente',
  home_total_commissions_paid: 'Total des Commissions Payées',
  home_active_users_online: 'Utilisateurs Actifs en Ligne',
  home_tasks_completed_today: 'Tâches Terminées Aujourd\'hui',
  security_row_title: 'Paramètres de sécurité',
  security_login_pw: 'Mot de passe de connexion',
  security_login_pw_desc: 'Modifier le mot de passe de connexion de votre compte',
  security_change_btn: 'Modifier',
  security_set_withdrawal_pw_title: 'Définir le mot de passe de retrait',
  security_set_withdrawal_pw_desc: 'Créez un PIN distinct pour autoriser les retraits',
  security_set_withdrawal_pw_btn: 'Définir le PIN',
  security_change_withdrawal_pw_title: 'Modifier le mot de passe de retrait',
  security_change_withdrawal_pw_desc: 'Mettez à jour votre PIN de retrait existant',
  security_change_withdrawal_pw_btn: 'Modifier',
  security_modal_set_withdrawal_title: 'Définir le mot de passe de retrait',
  security_modal_set_withdrawal_subtitle: 'Ce PIN sera requis chaque fois que vous effectuez un retrait.',
  security_modal_change_withdrawal_title: 'Modifier le mot de passe de retrait',
  security_field_current_pin: 'PIN de retrait actuel',
  security_field_new_pin: 'Nouveau PIN de retrait',
  security_field_new_pin_6: 'Nouveau PIN de retrait (6 chiffres)',
  security_field_confirm_pin: 'Confirmer le PIN',
  security_field_confirm_new_pin: 'Confirmer le nouveau PIN',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'Mot de passe actuel',
  account_security_tips_title: 'Recommandations de Sécurité',
  account_security_tips_desc: 'Améliorez la protection de votre compte en suivant ces bonnes pratiques simples.',
  tip_password_title: 'Mot de Passe Fort',
  tip_password_desc: 'Utilisez une combinaison de lettres, de chiffres et de symboles pour garantir la sécurité de votre compte.',
  tip_two_factor_title: 'Vérification d\'Identité',
  tip_two_factor_desc: 'Gardez vos coordonnées à jour pour recevoir des notifications de sécurité importantes.',
  tip_logout_title: 'Se Déconnecter Régulièrement',
  tip_logout_desc: 'Déconnectez-vous toujours de votre compte lorsque vous utilisez des ordinateurs publics ou partagés.',
  tip_sharing_title: 'Ne Jamais Partager l\'Accès',
  tip_sharing_desc: 'Notre équipe de support ne vous demandera jamais votre mot de passe. Ne partagez jamais vos identifiants avec quiconque.',

  // Demandes de Commande
  order_requests_title: 'Demandes de Commande',
  order_requests_desc: 'Envoyez une demande pour une nouvelle tâche ou une commande personnalisée. L\'administrateur examinera et attribuera les tâches en fonction de votre demande.',
  order_requests_new_btn: 'Demander une Nouvelle Commande',
  order_requests_table_id: 'ID de Demande',
  order_requests_table_data: 'Détails de la Demande',
  order_requests_table_status: 'Statut',
  order_requests_table_date: 'Soumis le',
  order_requests_table_actions: 'Actions',
  order_requests_cancel: 'Annuler',
  order_requests_cancel_confirm: 'Êtes-vous sûr de vouloir annuler cette demande de commande ?',
  order_requests_cancel_success: 'Demande de commande annulée avec succès.',
  order_requests_create_success: 'Demande de commande soumise avec succès.',
  order_requests_modal_title: 'Soumettre une Nouvelle Demande de Commande',
  order_requests_modal_desc: 'Veuillez fournir des informations détaillées sur la commande que vous souhaitez demander.',
  order_requests_field_data: 'Données de la Demande de Commande',
  order_requests_field_placeholder: 'ex : Je souhaite demander une commande personnalisée pour le Pack Premium.',
  order_requests_btn_submit: 'Soumettre la Demande',
  order_requests_btn_submitting: 'Envoi...',
  order_requests_empty: 'Aucune demande de commande trouvée.',
  order_requests_status_pending: 'En attente',
  order_requests_status_approved: 'Approuvé',
  order_requests_status_rejected: 'Rejeté',
  order_requests_status_cancelled: 'Annulé',
  order_requests_terms_title: 'Conditions de Commande Obligatoires',
  order_requests_term_1: 'Les nouvelles commandes seront attribuées dans les 24 à 48 heures suivant l\'approbation.',
  order_requests_term_2: 'Une fois libérées, les commandes ne peuvent être ni annulées, ni suspendues, ni modifiées.',
  order_requests_term_3: 'Toutes les commandes attribuées doivent être complétées avant tout retrait.',
  order_requests_term_4: 'Le fait de ne pas compléter les commandes peut affecter le statut de votre compte.',
  order_requests_term_5: 'Cette demande est finale et ne peut être annulée après soumission.',
  order_requests_policy_title: 'Politique de Non-Annulation',
  order_requests_policy_desc: 'En soumettant cette demande, vous reconnaissez que le nouveau lot de commandes est irrévocable. Une fois confirmé par notre système, aucune annulation, modification ou remboursement ne sera autorisé en aucune circonstance.',
  order_requests_accept_terms: 'J\'ai lu et je comprends parfaitement les conditions ci-dessus. Je reconnais qu\'une fois soumise, cette demande de commande ne peut être ni annulée ni modifiée, et j\'accepte de compléter toutes les commandes attribuées.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Politique de Retrait',
  orders_unlock_req: 'Conditions de Déblocage',
  orders_unlock_desc: 'Complétez votre premier lot de {{count}} commandes pour débloquer définitivement les retraits. Cette exigence unique garantit l\'intégrité de la plateforme et prévient les abus.',
  orders_daily_limits: 'Limites Quotidiennes de Commandes',
  orders_daily_limit_1: '{{count}} commandes par lot — vous devez toutes les terminer avant de demander le suivant',
  orders_daily_limit_2: 'Maximum {{count}} lots par jour ({{total}} commandes/jour)',
  orders_comm_rates: 'Taux de Commission',
  orders_comm_rates_desc: 'Les taux sont déterminés par la plateforme et le solde actuel de votre portefeuille :',
  orders_payout_timeline: 'Calendrier de Paiement',
  orders_payout_desc: 'Les retraits sont traités dans un délai de 24 à 48 heures. Les virements bancaires peuvent prendre de 3 à 5 jours ouvrables. Les retraits en crypto sont instantanés.',
  orders_processing_fee: 'Des frais de traitement de {{fee}}% s\'appliquent à tous les retraits pour couvrir les coûts de transaction.',
  orders_tips_title: 'Conseils pour Réussir',
  orders_tips_1: 'Complétez les commandes quotidiennement pour créer une dynamique et maximiser vos gains',
  orders_tips_2: 'Restez sur la page pendant le traitement pour assurer une finalisation correcte',
  orders_tips_3: 'Consultez régulièrement votre portefeuille pour suivre la croissance des commissions',
  orders_tips_4: 'Parrainez des amis pour gagner des commissions bonus sur leurs commandes',
  orders_tips_5: 'Contactez immédiatement l\'assistance si vous rencontrez des problèmes',
  orders_batch_approx: '{{count}} commandes/lot × moyenne ${{avg}} = environ ${{total}} par lot',

  // Settings
  settings_page_title: 'Paramètres',
  settings_page_desc: 'Gérez votre sécurité, votre confidentialité et vos préférences',
  settings_kyc_label: 'Vérification KYC',
  settings_kyc_desc: 'Vérification d\'identité',
  settings_security_label: 'Sécurité',
  settings_security_desc: 'Gestion des mots de passe',
  settings_language_label: 'Langue',
  settings_language_desc: 'Préférences régionales',
};